import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';

const ChangeCodeDialog = ({ open, product, onClose, onConfirm }) => {
  const [newCode, setNewCode] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const currentCode = String(product?.code || '');

  useEffect(() => {
    if (open) {
      setNewCode('');
      setConfirmation('');
      setError('');
    }
  }, [open, product?.id]);

  const handleConfirm = async () => {
    try {
      setSubmitting(true);
      setError('');
      await onConfirm(product, newCode.trim());
      onClose();
    } catch (changeError) {
      setError(changeError.message);
    } finally {
      setSubmitting(false);
    }
  };

  const canSubmit = newCode.trim()
    && newCode.trim() !== currentCode
    && confirmation.trim() === currentCode
    && !submitting;

  return (
    <Dialog open={open} onClose={submitting ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Change product code</DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          This queues a code change for every synced store. Use it only when the barcode really changed.
        </Alert>
        <DialogContentText sx={{ mb: 2 }}>
          Current code: <strong>{currentCode}</strong>
        </DialogContentText>
        <TextField
          autoFocus
          fullWidth
          label="New code"
          value={newCode}
          onChange={(event) => setNewCode(event.target.value)}
          margin="dense"
        />
        <TextField
          fullWidth
          label={`Type ${currentCode} to confirm`}
          value={confirmation}
          onChange={(event) => setConfirmation(event.target.value)}
          margin="dense"
          error={Boolean(confirmation) && confirmation !== currentCode}
        />
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>Cancel</Button>
        <Button color="warning" variant="contained" onClick={handleConfirm} disabled={!canSubmit}>
          Change code
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangeCodeDialog;
